import { TagsModal } from './TagsModal.main';

export { TagsModal };
